const mapDestinationCountryFromApi = (country) => ({
  name: country.name,
  id: country.countryId,
  isoCode: country.isO2CountryCode
})

const mapDestinationCountriesFromApi = (destinationCountries) => {
  return { countries: destinationCountries.map(mapDestinationCountryFromApi) }
}

export default {
  mapDestinationCountriesFromApi
}
